import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const API = '';

function DocumentAgent() {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [uploadMsg, setUploadMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState('');
  const [uploadedFile, setUploadedFile] = useState('');

  const [showMailModal, setShowMailModal] = useState(false);
  const [mailTo, setMailTo] = useState('');
  const [mailSubject, setMailSubject] = useState('AI 문서 분석 결과');
  const [mailSending, setMailSending] = useState(false);
  const [mailResult, setMailResult] = useState('');

  const handleUpload = async () => {
    if (!file) return alert('파일을 선택해주세요');
    setLoading(true);
    setSummary('');
    setAnswer('');
    setUploadedFile('');
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await fetch(`${API}/upload`, { method: 'POST', body: formData });
      const data = await res.json();
      setUploadMsg(data.message || data.error);
      if (data.summary) {
        setSummary(data.summary);
        setUploadedFile(data.filename || file.name);
      }
    } catch (e) {
      setUploadMsg('업로드 실패');
    }
    setLoading(false);
  };

  const handleAsk = async () => {
    if (!question) return alert('질문을 입력해주세요');
    setLoading(true);
    try {
      const res = await fetch(`${API}/ask`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question })
      });
      const data = await res.json();
      setAnswer(data.answer || data.error);
    } catch (e) {
      setAnswer('질문 실패');
    }
    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !loading) handleAsk();
  };

  const handleDownload = async (format) => {
    try {
      const res = await fetch(`${API}/prepare-download`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ answer, question })
      });
      const prepData = await res.json(); if (prepData.file_id) { window.open(`${API}/get-download/${prepData.file_id}`, '_self'); return; }
      const ext = { word: 'docx', pptx: 'pptx', excel: 'xlsx' };
    } catch (e) {
      alert('다운로드 실패');
    }
  };

  const openMailModal = () => {
    setMailTo('');
    setMailSubject('AI 문서 분석 결과');
    setMailResult('');
    setShowMailModal(true);
  };

  const handleSendMail = async () => {
    if (!mailTo.trim()) return alert('수신자 이메일을 입력해주세요.');
    setMailSending(true);
    setMailResult('');
    try {
      const res = await fetch(`${API}/send-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to: mailTo, subject: mailSubject, answer, question })
      });
      const data = await res.json();
      if (data.error) {
        setMailResult('error:' + data.error);
      } else {
        setMailResult('success:' + data.message);
      }
    } catch (e) {
      setMailResult('error:메일 전송에 실패했습니다.');
    }
    setMailSending(false);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      {/* 상단 네비게이션 */}
      <div style={{
        background: 'linear-gradient(135deg, #1a73e8, #4a9af5)',
        padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 16
      }}>
        <button onClick={() => navigate('/')}
          style={{
            background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white',
            width: 36, height: 36, borderRadius: 8, cursor: 'pointer', fontSize: 18,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M12 4l-6 6 6 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <div>
          <div style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>문서 분석 에이전트</div>
          <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>AI Agent Hub</div>
        </div>
      </div>

      {/* 본문 */}
      <div style={{ maxWidth: 800, margin: '24px auto', padding: '0 20px 40px' }}>
        <p style={{ color: '#666', marginTop: 0, marginBottom: 24 }}>
          문서를 업로드하면 AI가 내용을 분석하고, 질문에 답변합니다.
        </p>

        <div style={{ border: '1px solid #ddd', padding: 20, borderRadius: 8, marginBottom: 20, background: 'white' }}>
          <h2 style={{ marginTop: 0, fontSize: 17 }}>파일 업로드</h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 14 }}>
            {['PNG','JPG','GIF','BMP','TIFF','WEBP','PDF','DOCX','XLSX','TXT','CSV','JSON'].map(ext => (
              <span key={ext} style={{
                padding: '2px 10px', borderRadius: 12, fontSize: 13,
                background: ['PNG','JPG','GIF','BMP','TIFF','WEBP'].includes(ext) ? '#e8f4fd' :
                           ['PDF','DOCX','XLSX'].includes(ext) ? '#fef3e2' : '#e8f8e8',
                color: ['PNG','JPG','GIF','BMP','TIFF','WEBP'].includes(ext) ? '#1a73e8' :
                       ['PDF','DOCX','XLSX'].includes(ext) ? '#e67700' : '#2e7d32',
                border: '1px solid',
                borderColor: ['PNG','JPG','GIF','BMP','TIFF','WEBP'].includes(ext) ? '#a8d4f0' :
                             ['PDF','DOCX','XLSX'].includes(ext) ? '#f0d4a0' : '#a0d8a0',
              }}>{ext}</span>
            ))}
          </div>
          <input type="file"
            accept=".png,.jpg,.jpeg,.gif,.bmp,.tiff,.webp,.pdf,.docx,.xlsx,.xls,.txt,.csv,.json"
            onChange={e => setFile(e.target.files[0])} />
          <button onClick={handleUpload} disabled={loading}
            style={{ marginLeft: 10, padding: '8px 16px', background: '#1a73e8', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
            {loading ? '처리중...' : '업로드'}
          </button>
          {uploadMsg && <p style={{ color: 'green', marginTop: 10 }}>{uploadMsg}</p>}
        </div>

        <div style={{ border: '1px solid #ddd', padding: 20, borderRadius: 8, background: 'white', marginBottom: summary ? 20 : 0 }}>
          <h2 style={{ marginTop: 0, fontSize: 17 }}>{summary ? '문서에 대해 질문하기' : 'AI에게 질문'}</h2>
          <div style={{ display: 'flex', gap: 10 }}>
            <input type="text" value={question} onChange={e => setQuestion(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="업로드한 문서에 대해 질문하세요"
              style={{ flex: 1, padding: 10, fontSize: 16, borderRadius: 4, border: '1px solid #ccc' }} />
            <button onClick={handleAsk} disabled={loading}
              style={{ padding: '10px 20px', background: '#28a745', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 15, whiteSpace: 'nowrap' }}>
              {loading ? '생각중...' : '질문'}
            </button>
          </div>
          {answer && (
            <div style={{
              marginTop: 20, padding: 20, background: '#f8f9fa', borderRadius: 8,
              border: '1px solid #e9ecef', lineHeight: 1.8
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
                <div style={{ fontWeight: 'bold', color: '#495057', fontSize: 15 }}>답변</div>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                  {[
                    { fmt: 'word',  label: 'Word',  icon: 'W', bg: '#2b579a' },
                    { fmt: 'pptx',  label: 'PPT',   icon: 'P', bg: '#d24726' },
                    { fmt: 'excel', label: 'Excel', icon: 'X', bg: '#217346' },
                  ].map(({fmt, label, icon, bg}) => (
                    <button key={fmt} onClick={() => handleDownload(fmt)}
                      title={`${label}로 다운로드`}
                      style={{
                        display: 'flex', alignItems: 'center', gap: 5,
                        padding: '5px 12px', background: bg, color: 'white',
                        border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13, fontWeight: 'bold',
                      }}>
                      <span style={{
                        width: 20, height: 20, borderRadius: 3,
                        background: 'rgba(255,255,255,0.2)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 12, fontWeight: 'bold'
                      }}>{icon}</span>
                      {label}
                    </button>
                  ))}
                  <button onClick={openMailModal}
                    title="이메일로 공유"
                    style={{
                      display: 'flex', alignItems: 'center', gap: 5,
                      padding: '5px 12px', background: '#ea4335', color: 'white',
                      border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 13, fontWeight: 'bold',
                    }}>
                    <span style={{
                      width: 20, height: 20, borderRadius: 3,
                      background: 'rgba(255,255,255,0.2)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 14
                    }}>@</span>
                    메일 공유
                  </button>
                </div>
              </div>
              <div className="markdown-answer" style={{ color: '#212529', fontSize: 15 }}>
                <ReactMarkdown
                  remarkPlugins={[remarkGfm]}
                  components={{
                    h3: ({children}) => <h3 style={{ marginTop: 16, marginBottom: 8, fontSize: 16, color: '#1a73e8' }}>{children}</h3>,
                    strong: ({children}) => <strong style={{ color: '#c62828' }}>{children}</strong>,
                    ul: ({children}) => <ul style={{ paddingLeft: 20, margin: '8px 0' }}>{children}</ul>,
                    ol: ({children}) => <ol style={{ paddingLeft: 20, margin: '8px 0' }}>{children}</ol>,
                    li: ({children}) => <li style={{ marginBottom: 4 }}>{children}</li>,
                    p: ({children}) => <p style={{ margin: '8px 0' }}>{children}</p>,
                    table: ({children}) => <table style={{ borderCollapse: 'collapse', width: '100%', margin: '10px 0' }}>{children}</table>,
                    th: ({children}) => <th style={{ border: '1px solid #dee2e6', padding: '8px 12px', background: '#e9ecef', textAlign: 'left' }}>{children}</th>,
                    td: ({children}) => <td style={{ border: '1px solid #dee2e6', padding: '8px 12px' }}>{children}</td>,
                  }}
                >
                  {answer}
                </ReactMarkdown>
              </div>
            </div>
          )}
        </div>

        {/* 문서 요약 (질문 영역 아래) */}
        {summary && (
          <div style={{ border: '1px solid #1a73e8', padding: 20, borderRadius: 8, background: 'white' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <h2 style={{ margin: 0, fontSize: 17, color: '#1a73e8' }}>문서 요약</h2>
              {uploadedFile && (
                <span style={{ fontSize: 12, padding: '3px 10px', background: '#e8f4fd', color: '#1a73e8', borderRadius: 12 }}>{uploadedFile}</span>
              )}
            </div>
            <div style={{ fontSize: 14, lineHeight: 1.8, color: '#333' }}>
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  h3: ({children}) => <h3 style={{ marginTop: 12, marginBottom: 6, fontSize: 15, color: '#1a73e8' }}>{children}</h3>,
                  strong: ({children}) => <strong style={{ color: '#c62828' }}>{children}</strong>,
                  ul: ({children}) => <ul style={{ paddingLeft: 20, margin: '6px 0' }}>{children}</ul>,
                  ol: ({children}) => <ol style={{ paddingLeft: 20, margin: '6px 0' }}>{children}</ol>,
                  li: ({children}) => <li style={{ marginBottom: 4 }}>{children}</li>,
                  p: ({children}) => <p style={{ margin: '6px 0' }}>{children}</p>,
                }}
              >{summary}</ReactMarkdown>
            </div>
          </div>
        )}
      </div>

      {/* 메일 전송 모달 */}
      {showMailModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000
        }}
          onClick={(e) => { if (e.target === e.currentTarget) setShowMailModal(false); }}
        >
          <div style={{
            background: 'white', borderRadius: 12, width: '90%', maxWidth: 500,
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden'
          }}>
            <div style={{
              background: 'linear-gradient(135deg, #ea4335, #fb7160)',
              padding: '20px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
            }}>
              <div style={{ color: 'white', fontSize: 18, fontWeight: 'bold' }}>메일로 공유</div>
              <button onClick={() => setShowMailModal(false)}
                style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: 'white',
                  width: 30, height: 30, borderRadius: '50%', cursor: 'pointer', fontSize: 16 }}>
                X
              </button>
            </div>
            <div style={{ padding: 24 }}>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: 6, color: '#333', fontSize: 14 }}>
                  받는 사람
                </label>
                <input type="text" value={mailTo} onChange={e => setMailTo(e.target.value)}
                  placeholder="example@email.com (여러 명은 쉼표로 구분)"
                  style={{
                    width: '100%', padding: 10, fontSize: 14, borderRadius: 6,
                    border: '1px solid #ddd', boxSizing: 'border-box', outline: 'none'
                  }} />
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontWeight: 'bold', marginBottom: 6, color: '#333', fontSize: 14 }}>
                  제목
                </label>
                <input type="text" value={mailSubject} onChange={e => setMailSubject(e.target.value)}
                  style={{
                    width: '100%', padding: 10, fontSize: 14, borderRadius: 6,
                    border: '1px solid #ddd', boxSizing: 'border-box', outline: 'none'
                  }} />
              </div>
              <div style={{
                background: '#f8f9fa', borderRadius: 6, padding: 12, marginBottom: 16,
                border: '1px solid #e9ecef', maxHeight: 150, overflowY: 'auto'
              }}>
                <div style={{ fontSize: 12, color: '#999', marginBottom: 6 }}>미리보기</div>
                <div style={{ fontSize: 13, color: '#555' }}>
                  <div style={{ fontWeight: 'bold', color: '#1a73e8', marginBottom: 4 }}>질문: {question}</div>
                  <div style={{ whiteSpace: 'pre-wrap' }}>{answer.substring(0, 300)}{answer.length > 300 ? '...' : ''}</div>
                </div>
              </div>
              {mailResult && (
                <div style={{
                  padding: 12, borderRadius: 6, marginBottom: 16, fontSize: 14,
                  background: mailResult.startsWith('success') ? '#e8f5e9' : '#ffebee',
                  color: mailResult.startsWith('success') ? '#2e7d32' : '#c62828',
                  border: '1px solid',
                  borderColor: mailResult.startsWith('success') ? '#a5d6a7' : '#ef9a9a',
                }}>
                  {mailResult.split(':').slice(1).join(':')}
                </div>
              )}
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button onClick={() => setShowMailModal(false)}
                  style={{ padding: '10px 20px', background: '#f1f3f4', color: '#333', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}>
                  취소
                </button>
                <button onClick={handleSendMail} disabled={mailSending}
                  style={{
                    padding: '10px 24px', background: mailSending ? '#ccc' : '#ea4335',
                    color: 'white', border: 'none', borderRadius: 6,
                    cursor: mailSending ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 'bold'
                  }}>
                  {mailSending ? '전송중...' : '메일 보내기'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DocumentAgent;
